import Resource from '../Resource'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonCenterService extends Resource {
    async getActiveCenters() {
        const response = await this.axios.get('/centers/active')
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
}

export default new CommonCenterService()
